import { DeviceType } from "../api/generatedApi";

export const DEVICE_TYPE_SOMNOFY_SM100 = "vitalthings-somnofy-sm100";
export const DEVICE_TYPE_GUARDIAN_H10 = "vitalthings-guardian-h10";

export const SUPPORTED_DEVICE_TYPES: DeviceType[] = [
  DEVICE_TYPE_SOMNOFY_SM100,
  DEVICE_TYPE_GUARDIAN_H10,
];
